export const LOCALES: Record<string, string> = {
    ENGLISH: 'en',
    SPANISH: 'es',
};
